import FeedbackApi, { FeedbackRequest, FeedbackResponse } from '@/repositories/api/FeedbackApi';
import { Observable } from 'rxjs';

export default class FeedbackRepository {
    constructor(private readonly feedbackApi: FeedbackApi) {}

    public submitFeedback(feedback: FeedbackRequest): Observable<FeedbackResponse> {
        return this.feedbackApi.submitFeedback(feedback);
    }
}
